import { HttpClient } from '@angular/common/http'
import { computed, inject, Injectable, signal } from '@angular/core'

import { environment } from '../../../environments/environment'
import { ApiResponse } from '../types/response.type'
import { SupportChannel } from '../types/support-channel.type'
import { DomainService } from './domain.service'

@Injectable({ providedIn: 'root' })
export class SupportChannelService {
	private http = inject(HttpClient)

	private domainService = inject(DomainService)

	private channels = signal<SupportChannel[]>([])

	readonly whatsapp = computed(() => this.channels().find((c) => c.TYPE === 'whatsapp' && c.ENABLED) ?? null)

	readonly telegram = computed(() => this.channels().find((c) => c.TYPE === 'telegram' && c.ENABLED) ?? null)

	readonly hasAny = computed(() => !!this.whatsapp()?.WEB_LINK || !!this.telegram()?.WEB_LINK)

	fetch(): void {
		if (this.channels().length > 0) return
		this.http.get<ApiResponse<SupportChannel[]>>(`${environment.apiUrl}/api/white_label/support_channels/${this.domainService.domain}`).subscribe({
			next: (res) => {
				if (res?.status === 'ok' && Array.isArray(res.result)) {
					this.channels.set(res.result)
				}
			},
			error: (err) => console.error('Error fetching support channels', err),
		})
	}
}
